import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

/*
 * A new page starts at its top.
 *
 * `instant` rather than the two-argument form: the redesigned landing turns on
 * `scroll-behavior: smooth` for the document while it is mounted, and a plain
 * `scrollTo` obeys that — which would animate the whole way back up on every
 * route change, over content that has already been swapped. The keyword pins
 * this one jump regardless of what the stylesheet asks for; everywhere else
 * behaves exactly as before, since nothing else sets `scroll-behavior`.
 */
history.listen(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));

export default history;